(function ($) {
  DJ.addBehavior('brio-dropdown', '.brio-dropdown', {
    attach: function () {
      const dropdown = this;
      const openBtn = dropdown.querySelector('.brio-dropdown__open-btn');
      const dropdownBody = dropdown.querySelector('.brio-dropdown__content');
      const dropdownOpenedClass = 'brio-dropdown--show';
      let currentBreakpoint = DJ.bp.name;

      /**
       * Return false if no dropdown button or content.
       */
      if (!openBtn || !dropdownBody) {
        return false;
      }

      /**
       * Close dropdown.
       */
      const closeDropdown = () => {
        dropdown.classList.remove(dropdownOpenedClass);
        $('body').off('click.bodyBrioDropdown');
        $(document).off('keydown.escBrioDropdown');
        openBtn.setAttribute('aria-expanded', false);
      };

      /**
       * Close on body click.
       */
      const onBodyClick = () => {
        $('body').on('click.bodyBrioDropdown', (e) => {
          if (!($(e.target).closest('.brio-dropdown__content-inner').length)) {
            closeDropdown();
          }
        });
      };

      /**
       * Close dropdown on esc press.
       */
      const onEscKeyPress = () => {
        $(document).on('keydown.escBrioDropdown', (e) => {
          if (e.code === 'Escape') {
            closeDropdown();
          }
        });
      };

      /**
       * Open dropdown on button click.
       */
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (!dropdown.classList.contains(dropdownOpenedClass)) {
          dropdown.classList.add(dropdownOpenedClass);
          openBtn.setAttribute('aria-expanded', true);

          const bodyTimer = setTimeout(() => {
            onBodyClick();
            onEscKeyPress();
            clearTimeout(bodyTimer);
          }, 50);
        } else {
          closeDropdown();
        }

        return true;
      });

      /**
       * Close dropdown on breakpoint change.
       */
      DJ.on('changeBreakpoint', function () {
        setTimeout(function () {
          if (currentBreakpoint !== DJ.bp.name) {
            closeDropdown();
            currentBreakpoint = DJ.bp.name;
          }
        }, 500);
      });

      return true;
    }
  });
})(jQuery);
